import {
  withStyles,
} from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import React from 'react';
import classes from './tabs.module.scss';

interface Iprops {
  tabLabels: string[];
  selected?: number;
}

const styles = (theme: any) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
});

class NavigationTabs extends React.Component<Iprops> {
  state = {
    value: this.props.selected,
  };

  handleChange = (event: any, value: any) => {
    this.setState({
      value,
    });
  };

  render() {
    const {
      value,
    } = this.state;
    const {
      tabLabels, children,
    } = this.props;

    return (
      <div>
        <Tabs value={value} onChange={this.handleChange} className={classes.tab} indicatorColor="primary">
          {tabLabels.map((label) => <Tab key={label} label={label} />)}
        </Tabs>
        {React.Children.map(children, (child, i) => (i === value ? child : null))}
      </div>
    );
  }
}

export default withStyles(styles)(NavigationTabs);
